import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useSecureData } from "../hooks/isLogged";
import FormCreate from "../Components/FormCreate";
import { NavbarWithoutLogo } from "../Components/Navbar";

export default function CreateData() {
  const navigate = useNavigate();
  const { data, loading, error } = useSecureData(localStorage.getItem("token"));

  useEffect(() => {
    if (error && !loading) {
      navigate("/login");
    }
  }, [data, loading, error]);

  return (
    <div className="bg-[#F2F4F5] min-h-screen">
      <NavbarWithoutLogo label={"Tambah Data"} />
      <div className="pt-20 pb-5 flex justify-center">
        <div className="w-full border border-black rounded-md p-5 max-w-screen-md bg-white">
          <h1 className="font-bold mb-5 text-xl">SPESIFIKASI</h1>
          <FormCreate />
        </div>
      </div>
    </div>
  );
}
